import React, { useCallback, useMemo } from 'react';
import { useNotificationsContext } from '@/src/features/app/store/notifications/context';
import { DiaryNotificationSeverity } from '@/src/features/app/store/notifications/state';
import { CToast, CSeverity, CSnackbar } from '@skozub/react-components';

export const Notifications = (): React.JSX.Element => {
  const { state, close } = useNotificationsContext();

  const onClose = useCallback((guid: string) => {
    return () => close(guid);
  }, [close]);

  const severityMap = useMemo(() => {
    return {
      [DiaryNotificationSeverity.Success]: CSeverity.Success,
      [DiaryNotificationSeverity.Info]: CSeverity.Info,
      [DiaryNotificationSeverity.Warning]: CSeverity.Warning,
      [DiaryNotificationSeverity.Error]: CSeverity.Error,
    };
  }, []);

  return (
    <CSnackbar>
      {state.notifications.map(notification => (
        <CToast
          key={notification.guid}
          onClose={onClose(notification.guid)}
          severity={severityMap[notification.severity]}
        >
          {notification.message}
        </CToast>
      ))}
    </CSnackbar>
  );
};
